import { render } from "./FooterMobile.vue?vue&type=template&id=56c357c5&ts=true"
import script from "./FooterMobile.vue?vue&type=script&lang=ts"
export * from "./FooterMobile.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__